import phosphorIcons from './phosphorIcons';
import lucideIcons from './lucideIcons';
import icons from './iconPath';

interface IconProps {
  icon: keyof typeof icons;
  color?: string;
  width?: number;
  height?: number;
}

const Icon = ({ icon, color, width, height }: IconProps): JSX.Element => {
  const IconPath = icons[icon];
  const phosphor = process.env.REACT_APP_ICON_SET === 'phosphor-fill' ? phosphorIcons[icon] : undefined;
  if (phosphor) {
    return <>{phosphor.component({
      'aria-hidden': true,
      style: { width: width ?? phosphor.width, height: height ?? phosphor.height },
      color: color ?? phosphor.color,
    })}</>;
  }

  const alternate = process.env.REACT_APP_ICON_SET === 'lucide' ? lucideIcons[icon] : undefined;
  if (alternate) {
    const { component: LucideIcon, width: defaultWidth, height: defaultHeight, color: defaultColor } = alternate;
    return (
      <LucideIcon
        aria-hidden="true"
        width={width ?? defaultWidth}
        height={height ?? defaultHeight}
        color={color ?? defaultColor}
      />
    );
  }

  return (
    <>{IconPath && <IconPath color={color} width={width} height={height} />}</>
  );
};

export default Icon;
